import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Form.scss';
import { toast } from 'react-toastify';

const SignUp = () => {
  const [isOpen, setIsOpen] = useState(true);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    cpassword: '',
    age: '',
    avatar: null,
  });

  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState('');
  const [token, setToken] = useState('');
  const [timer, setTimer] = useState(300);
  const navigate = useNavigate();

  useEffect(() => {
    if (otpSent && timer > 0) {
      const interval = setInterval(() => setTimer((prev) => prev - 1), 1000);
      return () => clearInterval(interval);
    }
  }, [otpSent, timer]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleFileChange = (e) => {
    setFormData({
      ...formData,
      avatar: e.target.files[0],
    });
  };

  const handleSendOtp = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/send-otp`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: formData.email }),
      });

      const data = await res.json();
      if (res.ok) {
        setOtpSent(true);
        setToken(data.token);
        setTimer(300);
        toast.success('OTP sent to your email!');
      } else {
        toast.error(data.error || 'Failed to send OTP');
      }
    } catch (err) {
      console.error('Send OTP Error:', err);
    }
  };

  const handleVerifyOtp = async () => {
    if (!otp) return toast.warning('Please enter OTP');

    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/verify-otp`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: formData.email, otp, token }),
      });

      const data = await res.json();
      if (res.ok) {
        await registerUser(); 
      } else {
        toast.error(data.error || 'Invalid OTP');
      }
    } catch (err) {
      console.error('OTP verification error:', err);
    }
  };

  const registerUser = async () => {
    const formDataToSend = new FormData();
    formDataToSend.append('name', formData.name);
    formDataToSend.append('email', formData.email);
    formDataToSend.append('password', formData.password);
    formDataToSend.append('age', formData.age);
    if (formData.avatar) {
      formDataToSend.append('avatar', formData.avatar);
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/users`, {
        method: 'POST',
        body: formDataToSend,
      });

      if (!response.ok) throw new Error('Failed to sign up');

   toast.success('Signup successful!');
      navigate('/login');
    } catch (error) {
      console.error('Signup error:', error);
     toast.error('Signup failed. Please try again.');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.password !== formData.cpassword) return toast.error('Passwords do not match!');
    await handleSendOtp(); 
  };

  const handleClose = () => {
    setIsOpen(false);
    navigate('/login');
  };

  const formatTime = (sec) => {
    const m = Math.floor(sec / 60);
    const s = sec % 60;
    return `${m}:${s.toString().padStart(2, '0')}`;
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.style.overflow = 'hidden';
    document.body.classList.add('login-open');

    return () => {
      document.body.style.overflow = 'auto';
      document.body.classList.remove('login-open');
    };
  }, []);

  return (
    <>
      {isOpen && <div className="overlay" onClick={handleClose}></div>}
      {isOpen && (
        <div className="page">
          <div className="form-container">
            <span className="close-btn" onClick={handleClose}>
              &times;
            </span>

            <h2>{otpSent ? 'Verify OTP' : 'Sign Up'}</h2>
            <form onSubmit={handleSubmit}>
              {!otpSent ? (
                <>
                  <div className="form-group">
                    <label htmlFor="avatar">Profile Picture (Optional):</label>
                    <input type="file" name="avatar" accept="image/*" onChange={handleFileChange} />
                  </div>

                  <div className="form-group">
                    <label>Name:</label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder="Enter your name"
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label>Email:</label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="Enter your email"
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label>Password:</label>
                    <input
                      type="password"
                      name="password"
                      value={formData.password}
                      onChange={handleChange}
                      placeholder="Enter your password"
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label>Confirm Password:</label>
                    <input
                      type="password"
                      name="cpassword"
                      value={formData.cpassword}
                      onChange={handleChange}
                      placeholder="Re-enter your password"
                      required
                    />
                  </div>

                  <button type="submit">Send OTP</button>
                </>
              ) : (
                <>
                  <div className="form-group">
                    <label>Enter OTP (expires in {formatTime(timer)}):</label>
                    <input
                      type="text"
                      value={otp}
                      onChange={(e) => setOtp(e.target.value)}
                      placeholder="6-digit OTP"
                      maxLength={6}
                      required
                    />
                  </div>

                  <button type="button" onClick={handleVerifyOtp}>
                    Verify OTP
                  </button>

                  {timer <= 0 && (
                    <button
                      type="button"
                      style={{ marginTop: '10px' }}
                      onClick={handleSendOtp}
                    >
                      Resend OTP
                    </button>
                  )}
                </>
              )}
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default SignUp;
